import { NavegacaoService } from '@/core/services/navegacao/navegacao.service';
import { TemaService } from '@/core/services/tema/tema.service';
import { Component, inject } from '@angular/core';

/** Painel de configurações do shell. Só chama o `NavegacaoService` e o `TemaService`. */
@Component({
  selector: 'app-right-config',
  standalone: true,
  imports: [],
  templateUrl: './right-config.component.html',
  styleUrl: './right-config.component.scss'
})
export class RightConfigComponent {
  protected readonly navegacao = inject(NavegacaoService);
  protected readonly tema = inject(TemaService);
}
